import g from "./index.es26.js";
const b = [
  "#5b1DE6",
  "#F594A0",
  "#8CBDF0",
  "#007A86",
  "#dbae37",
  "#8d230f",
  "#fb6542",
  "#ffe000",
  "#6ab187",
  "#d93304",
  "#5f3f6b",
  "#c48bc2",
  "#98DBC6"
], i = [
  "#fff",
  "#000",
  "#000",
  "#fff",
  "#000",
  "#fff",
  "#000",
  "#000",
  "#000",
  "#fff",
  "#fff",
  "#000",
  "#000"
], h = [
  "zigzag-vertical",
  "dot",
  "diagonal-right-left",
  "box",
  "dash",
  "diamond-box",
  "disc",
  "line",
  "dot-dash",
  "cross",
  "diagonal"
], p = (r = {}) => {
  const t = r.colors || b, s = r.patternColors || i, o = r.patterns || h, f = (e) => {
    const n = e.datasetIndex;
    if (n < t.length)
      return t[n];
    const a = n % t.length, l = n % o.length;
    return g.draw(
      o[l],
      t[a],
      s[a]
    );
  }, d = r.borders || [], c = r.borders && r.borders.length ? (e) => {
    const n = e.datasetIndex;
    return d[n % d.length];
  } : f;
  return {
    background: f,
    border: c,
    colorString: (e) => t[e % t.length]
  };
};
export {
  p as createBackgroundColorFunctions
};
//# sourceMappingURL=index.es71.js.map
